import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  template: `
    <div class="snackbar">
      <div class="snackbar__text">
        <h5>Can't connect to the server.</h5>
        <p>Server communication failure. Try again later or contact your administrator.</p>
      </div>
      <button
        color="accent"
        (click)="snackBarRef.dismiss()"
      >
        OK
      </button>
    </div>`,
  styleUrls: [`../snack-bar.scss`],
  encapsulation: ViewEncapsulation.None,
})

export class ServerDisconnectedErrorComponent {
  constructor(public snackBarRef: MatSnackBarRef<any>){
    setTimeout(() => {
      this.snackBarRef.dismiss();
    }, 3000);
  }
}
